import React from "react";
import InstructionModal from "./InstructionModal";
import ConfirmationDialog from "./ConfirmationDialog";
import UnattemptedQuestionsDialog from "./UnattemptedQuestionsDialog";
import TimeExpiryDialog from "./TimeExpiryDialog";

const InstructionWrapper = ({
  instructionState,
  onInstructionNext,
  onInstructionClose,
  onConfirmationConfirm,
  onConfirmationClose,
  onUnattemptedContinue,
  onUnattemptedClose,
  onTimeExpiryContinue,
  timeRemaining,
  unattemptedCount,
  nextSection,
}) => {
  return (
    <>
      {/* Instruction Modal */}
      <InstructionModal
        open={instructionState.showInstructions}
        section={instructionState.currentSection}
        part={instructionState.currentPart}
        mode={instructionState.mode}
        onNext={onInstructionNext}
        onClose={onInstructionClose}
        onAutoClose={onInstructionClose}
      />

      {/* Confirmation Dialog */}
      <ConfirmationDialog
        open={instructionState.showConfirmation}
        type={instructionState.confirmationType}
        onConfirm={onConfirmationConfirm}
        onClose={onConfirmationClose}
      />

      {/* Unattempted Questions Dialog */}
      <UnattemptedQuestionsDialog
        open={instructionState.showUnattempted}
        count={unattemptedCount}
        onContinue={onUnattemptedContinue}
        onClose={onUnattemptedClose}
      />

      {/* Time Expiry Dialog */}
      <TimeExpiryDialog
        open={instructionState.showTimeExpiry}
        timeRemaining={timeRemaining}
        nextSection={nextSection}
        onContinue={onTimeExpiryContinue}
      />
    </>
  );
};

export default InstructionWrapper;
